import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import { StarOutlined, MutedOutlined } from '@ant-design/icons';
import { Badge, Col, Row, Tag, theme, Typography } from 'antd';

import * as actions from '../../store/actions';

import { AppDispatch, RootState } from '../../../../store';
import { SmsChat } from '../../models';

import './styles.less';

const { Title } = Typography;

export type ChatItemProps = {
  updateMessageControl: () => void;
  item: SmsChat;
};

const ChatItem = ({ updateMessageControl, item }: ChatItemProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { token } = theme.useToken();

  const { selectedChatItem } = useSelector((state: RootState) => state.smses);
  const { smsSetting } = useSelector((state: RootState) => state.smsSetting);

  const onChatClick = (value: SmsChat) => {
    let oldChatId = selectedChatItem?.smsChatId;
    dispatch(actions.setSelectedChatItem(value));

    if (value.smsChatId !== oldChatId) {
      updateMessageControl();
    }
  };

  const isMuteOffset = (item.starred ? [-27, 15] : [-10, 15]) as [number, number];

  const unreadCountOffset = (item.starred && item.isMute ? [-47, 15] : item.starred || item.isMute ? [-30, 15] : [-13, 15]) as [number, number];

  return (
    <Badge count={item.starred ? <StarOutlined /> : 0} offset={[-10, 15]} onClick={() => onChatClick(item)} className="chat-list-item">
      <Badge
        count={item.isMute && smsSetting?.notificationsOnlyForRecipient === true ? <MutedOutlined style={{ color: '#a72029' }} /> : 0}
        offset={isMuteOffset}
      >
        <Badge count={item.unreadCount} offset={unreadCountOffset}>
          <Tag className="inside-badge-chat-item" color={selectedChatItem?.smsChatId === item.smsChatId ? token.colorPrimary : 'default'}>
            <Title level={5} className="message-title">
              {item.chatName}
            </Title>

            <Row className="infinite-scroll-item-date">
              <Col span={8}>{item.phoneNumber}</Col>
              <Col span={8} offset={8} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                {' '}
                {moment(item.lastSmsDate).format('h:mm:ss A')}{' '}
              </Col>
            </Row>
          </Tag>
        </Badge>
      </Badge>
    </Badge>
  );
};

export default ChatItem;
